export enum Status {
  Active = 1,
  InActive = 2,
  PendingVerification = 3,
  Deleted = 4,
}
